import React, { useState, useEffect } from 'react';
import { getCropTypes, createCropType, deleteCropType } from '../../services/v2/adminService';
import TableHeader from '../../shared/components/tableHeader/TableHeader';

const CropTypeAdmin = () => {
    const [cropTypes, setCropTypes] = useState([]);
    const [name, setName] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const TABLE_HEADERS = ['Nombre del Cultivo', 'Acciones'];

    useEffect(() => {
        fetchCropTypes();
    }, []);

    const fetchCropTypes = async () => {
        setIsLoading(true);
        try {
            const data = await getCropTypes();
            setCropTypes(data || []);
        } catch (error) {
            console.error('Error fetching crop types', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        try {
            await createCropType({ name });
            setName('');
            fetchCropTypes();
        } catch (error) {
            console.error('Error creating crop type', error);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('¿Estás seguro de eliminar este tipo de cultivo?')) return;
        try {
            await deleteCropType(id);
            fetchCropTypes();
        } catch (error) {
            console.error('Error deleting crop type', error);
        }
    };

    return (
        <div className="flex flex-col">
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-bold text-gray-800">Gestionar Tipos de Cultivo</h2>
            </div>

            {/* Quick Add Form */}
            <form onSubmit={handleCreate} className="flex flex-col md:flex-row gap-4 mb-8 bg-gray-50 p-4 rounded-lg border border-gray-100">
                <div className="flex-1">
                    <input 
                        type="text" 
                        placeholder="Nombre (ej. Tomate, Arándano...)" 
                        value={name} 
                        onChange={(e) => setName(e.target.value)} 
                        required 
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                </div>
                <button 
                    type="submit" 
                    className="px-6 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors shadow-sm"
                >
                    Agregar Tipo
                </button>
            </form>

            {isLoading ? (
                <div className="text-center py-10 text-gray-500">Cargando tipos de cultivo...</div>
            ) : (
                <div className="relative overflow-x-auto shadow-sm border border-gray-200 rounded-lg">
                    <table className="w-full text-sm text-left text-gray-500">
                        <TableHeader headerOptions={TABLE_HEADERS} />
                        <tbody className="divide-y divide-gray-200">
                            {cropTypes.length === 0 ? (
                                <tr>
                                    <td colSpan={2} className="px-6 py-4 text-center text-gray-400">No hay registros</td>
                                </tr>
                            ) : (
                                cropTypes.map(ct => (
                                    <tr key={ct.id} className="bg-white hover:bg-gray-50 transition-colors">
                                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                            {ct.name}
                                        </th>
                                        <td className="px-6 py-4 flex gap-2">
                                            <button 
                                                onClick={() => handleDelete(ct.id)}
                                                className="p-1 text-red-600 hover:bg-red-50 rounded-full transition-colors"
                                                title="Eliminar"
                                            >
                                                <span className="material-icons-outlined">delete</span>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default CropTypeAdmin;
